import React from 'react';
import { Route } from 'react-router-dom';
import QuizChosen from './quiz/quizChosen';

export default <Route path="homepage/quizzes/quiz" component={QuizChosen} />;
